import React from 'react';

import { Provider } from 'react-redux';
import {
  Router,
  Route,
  Switch
} from 'react-router-dom';
import ReactGA from 'react-ga';

import store, { history } from '../../core/store.js';
import { google_analytics_id } from '../../config/constants';
import { isProduction } from '../../utils/environment';
import { PrivateRoute } from '../generic';
import { AuthedLayout, UnauthedLayout} from '../layouts';
import './index.css';

import { auth } from '../../utils/sessions';

//load tracking libraries if this is the production environment
if(isProduction()) {
    let customSessionDimensionSent = false;

    //initialize google analytics and setup listener to track page views
    ReactGA.initialize(google_analytics_id);
    history.listen((location) => {

        //send the custom session variable if associationName is sent and we haven't previously sent it
        if(!customSessionDimensionSent){
            const assocName = auth.getAssociationName();
            if(assocName) {
                ReactGA.set({dimension1: assocName});
                customSessionDimensionSent = true;
            }
        }

        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    });

    //load hotjar tracking script
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:675160,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}

const App = () => (
    <Provider store={store}>
        <Router history={history}>
            <div>
                <Switch>
                    <Route path="/error" component={UnauthedLayout} />
                    <PrivateRoute path="/" component={AuthedLayout} />
                </Switch>
            </div>
        </Router>
    </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.jsx